<template>

  <v-row     class="d-flex flex-row-reverse"  >
    <v-btn  :key="$vuetify.theme.dark" @click="$vuetify.theme.dark = !$vuetify.theme.dark" class="ma-2" large small icon>
      <v-icon :class="$vuetify.theme.dark? 'white--text' :'black--text'">
        {{ $vuetify.theme.dark ? "brightness_2" : "wb_sunny" }}
      </v-icon>
    </v-btn>



    <v-menu offset-y right nudge-bottom="14" min-width="230" d-none d-lg-block content-class="user-profile-menu-content d-lg-none">
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="messages = 0" class="d-none d-lg-block ma-2" large small v-bind="attrs" v-on="on" icon>
          <v-badge color="red accent-4" content="2+" left dot transition="slide-y-transition">
            <v-hover v-model="hover">
              <v-icon :class="$vuetify.theme.dark? 'white--text' :'black--text'">notifications</v-icon>
            </v-hover>
          </v-badge>
        </v-btn>
      </template>

      <v-list subheader two-line>


        <v-list-item v-for="folder in folders" :key="folder.title">
          <v-list-item-avatar>
            <v-icon :class="$vuetify.theme.dark? 'white--text' :'black--text'">
              mdi-folder
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="folder.title"></v-list-item-title>

            <v-list-item-subtitle v-text="folder.subtitle"></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon>
              <v-icon color="grey lighten-1">mdi-information</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-subheader inset>Files</v-subheader>

        <v-list-item v-for="file in files" :key="file.title">
          <v-list-item-avatar>
            <v-icon :class="file.color" dark v-text="file.icon"></v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="file.title"></v-list-item-title>

            <v-list-item-subtitle v-text="file.subtitle"></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon>
              <v-icon color="grey lighten-1">mdi-information</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>




    <v-menu offset-y left nudge-bottom="14"  min-width="230" d-lg-none content-class="user-profile-menu-content ">
      <template v-slot:activator="{ on, attrs }">
        <v-badge bottom overlap offset-x="16" offset-y="16" class="d-none d-lg-block" dot>
          <v-avatar class="d-none d-lg-block ma-2" size="45px"  v-bind="attrs" v-on="on">
            <v-img :src="require('../../assets/images/users/2.png')"></v-img>
          </v-avatar>
        </v-badge>
      </template>
      <v-list>
        <div class="pb-3 pt-2">
          <v-badge bottom overlap offset-x="12" offset-y="12" class="ms-4" dot>
            <v-avatar size="40px">
              <v-img :src="require('../../assets/images/users/2.png')"></v-img>
            </v-avatar>
          </v-badge>
          <div class="d-inline-flex flex-column justify-center ms-3" style="vertical-align: middle">
            <span class="text--primary font-weight-semibold mb-n1">
              John Doe
            </span>
            <small class="text--disabled text-capitalize">Admin</small>
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Profile -->
        <v-list-item @click="goProfile()" link>
          <v-list-item-icon class="me-2">
            <v-icon size="22">account_box </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Email -->
        <v-list-item @click="goTrader()" link>
          <v-list-item-icon class="me-2">
            <v-icon size="22"> markunread_mailbox</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Market</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Chat -->
        <v-list-item @click="goWallet()" link>
          <v-list-item-icon class="me-2">
            <v-icon size="22"> question_answer</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>My Wallet</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-badge inline color="error" content="2"> </v-badge>
          </v-list-item-action>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <!-- Settings -->
        <v-list-item @click="goSettings()" link>
          <v-list-item-icon class="me-2">
            <v-icon size="22">settings </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Pricing -->
        <v-list-item @click="goPrice()" link>
          <v-list-item-icon class="me-2">
            <v-icon size="22">money </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Pricing</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- FAQ -->
        <v-list-item @click="goInfo()" link>
          <v-list-item-icon class="me-2">
            <v-icon size="22">bolt </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>FAQ</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <!-- Logout -->
        <v-list-item :to="{ path: '/'}" link>
          <v-list-item-icon class="me-2">
            <v-icon size="22"> arrow_forward</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-row>
</template>
<script>
  import BaseSearch from './BaseSearch'
  export default {
    props: ['hover'],
    components: {
      BaseSearch
    },
    data: () => ({
      files: [{
          color: 'green',
          icon: 'mdi-clipboard-text',
          subtitle: 'Jan 20, 2014',
          title: 'Buy',
        },
        {
          color: 'green',
          icon: 'mdi-gesture-tap-button',
          subtitle: 'Jan 10, 2014',
          title: 'Transaction',
        },
      ],
      folders: [{
          color: 'green',
          subtitle: 'Jan 9, 2014',
          title: 'Transaction',
        },
        {
          color: 'red',
          subtitle: 'Jan 17, 2014',
          title: 'Trader',
        },
        {
          color: 'red',
          subtitle: 'Jan 28, 2014',
          title: 'Sell',
        },
      ],
    }),
    methods: {
      goProfile() {
        return this.$router.push("/users/profile");
      },
      goWallet() {
        return this.$router.push("/users/wallet");
      },
      goSettings() {
        return this.$router.push("/users/settings");
      },
      goTrader() {
        return this.$router.push("/markets/market-trade");
      },
      goPrice() {
        return this.$router.push("/exchange/exchange-price");
      },
      goInfo() {
        return this.$router.push("/others/symbol-info");
      },
    },
  }
</script>
<style lang="scss">
  .user-profile-menu-content {
    .v-list-item {
      min-height: 2.5rem !important;
      margin-top:-5px;

    }
  }
</style>